import { getElementById } from "../services/dom";
import messageTemplate from "../templates/components/message.html?raw";

export default class Message extends HTMLElement {
  private container: HTMLDivElement;
  private messageOuter: HTMLElement;
  private messageText: HTMLElement;
  constructor() {
    super();

    this.container = document.getElementById("section-message") as HTMLDivElement;
    this.container.classList.add("mx-auto", "px-2");
    this.container.innerHTML = messageTemplate;

    this.messageOuter = getElementById("message-outer");
    this.messageText = getElementById("message-text");
  }

  public async timedMessage(text: string) {
    // this.messageText.classList.remove("hidden");
    this.fadeIn(this.messageOuter);
    this.messageText.textContent = text;
    await new Promise(f => setTimeout(f, 3000));
    this.fadeOut(this.messageOuter);
    // this.messageText.classList.add("hidden");
  }

  private fadeIn(element: HTMLElement) {
    var op = 0.1;  // initial opacity
    element.style.removeProperty("display");
    var timer = setInterval(function () {
        if (op >= 1){
            clearInterval(timer);
        }
        (element.style.opacity as unknown as number) = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1;
    }, 10);
  }

  private fadeOut(element: HTMLElement) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = "none"
        }
        (element.style.opacity as unknown as number) = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 50);
  }
}

customElements.define("message-bar", Message);
